import React from "react";
//Limitless imports
import { log as logger } from "@limitless/common/utils/Logging";
import { uniqueArrayBy } from "@limitless/common/utils/array-helper/ArrayHelper";
import { useNotificationContext } from "@limitless/common/hooks";
import { fetchCustomerHistory } from "../../apis/customer-message-history-api/CustomerMessageHistoryAPI";
import { useCustomerContext } from "../customer/CustomerContext";
import ClientContext from "@limitless/common/utils/client-context/ClientContext";
import { orderMessages } from "./CustomerHistoryHookHelper";
const INITIAL_STATE = {
  activeMessages: [],
  previousMessages: [],
  loading: false
};
const isMessageActive = message => {
  if (message.state === "closed") {
    return false;
  }
  if (message.custResolved) {
    return false;
  }
  if (message.accepted && message.acceptedDate && message.customerScore && message.custTestimonial) {
    return false;
  }
  return true;
};
export const useCustomerHistory = delayNonEssentialCalls => {
  const [history, setHistory] = React.useState(INITIAL_STATE);
  const [sessionMessages, setSessionMessages] = React.useState([]);
  const {
    customer
  } = useCustomerContext();
  const {
    addFailureNotification
  } = useNotificationContext();
  const log = logger.getLogger("useCustomerHistory");
  React.useEffect(() => {
    //only load history if we have the email address hash
    if (customer.customerEmailHash && !delayNonEssentialCalls) {
      loadHistory();
    }
    if (ClientContext._customerUtsc && customer.customerKey) {
      loadHistory();
    }
  }, [customer.customerEmailHash, customer.customerKey]);
  React.useEffect(() => {
    if (ClientContext._customerUtsc) {
      loadHistory();
    }
  }, []);
  React.useEffect(() => {
    if (!history.loading) {
      processHistoryMessages([...sessionMessages, ...history.activeMessages, ...history.previousMessages]);
    }
  }, [sessionMessages, history.loading]);
  const loadHistory = () => {
    setHistory({
      ...history,
      loading: true
    });
    fetchCustomerHistory(customer, result => {
      if (!result.hasError) {
        log.debug(`${sessionMessages.length} session message`);
        log.debug(`${result.length} from history api`);
        const historyMessages = result.concat(sessionMessages);
        processHistoryMessages(historyMessages);
      } else {
        if (!result.shouldSupressError) {
          addFailureNotification("Unable to retrieve history");
        }
        setHistory({
          ...history,
          loading: false
        });
      }
    });
  };
  const addMessageToHistory = message => {
    const index = sessionMessages.findIndex(m => m.messageId === message.messageId);
    let newSessionMessages;
    if (index === -1) {
      newSessionMessages = [...sessionMessages, message];
    } else {
      newSessionMessages = [...sessionMessages];
      newSessionMessages.splice(index, 1, message);
    }
    setSessionMessages(newSessionMessages);
  };
  const updateHistoryMessage = message => {
    const allMessages = [...sessionMessages, ...history.activeMessages, ...history.previousMessages];
    const index = allMessages.findIndex(m => m.messageId === message.messageId);
    allMessages.splice(index, 1, message);
    processHistoryMessages(allMessages);
  };

  /**
   * pretty inefficient, but will do for now
   *
   * @param {array} historyMessages
   */
  const processHistoryMessages = historyMessages => {
    const uniquiehistoryMessages = uniqueArrayBy(historyMessages, "messageId");
    log.debug(`${uniquiehistoryMessages.length} history messages`, uniquiehistoryMessages);
    const activeMessages = [];
    const previousMessages = [];
    uniquiehistoryMessages.map(message => {
      //guard for some strange platform behaviour
      if (message.dialogues.length !== 0) {
        if (isMessageActive(message)) {
          activeMessages.push(message);
        } else {
          previousMessages.push(message);
        }
      }
    });
    setHistory({
      ...history,
      loading: false,
      activeMessages: orderMessages(activeMessages, message => {
        const lastDialogue = message.dialogues[message.dialogues.length - 1];
        return lastDialogue.updated;
      }),
      previousMessages: orderMessages(previousMessages, "created")
    });
  };
  return {
    history,
    addMessageToHistory,
    updateHistoryMessage,
    loadHistory
  };
};